module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> <h3>Talk to a Shipping Expert</h3> </section> <form id=\"lead-form\"> <section class=\"modal-body\"> <div class=\"form-group ")
    ; __append(escapeFn( locals.email ? 'hidden' : '' ))
    ; __append("\"> <label class=\"control-label\" for=\"lead-email\">Contact Email</label> <input class=\"form-control\" id=\"lead-email\" name=\"lead[email]\" placeholder=\"Email Address\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.email ))
    ; __append("\" required> </div> <div class=\"form-group\"> <label class=\"control-label\" for=\"volume-option\">Packages Per Month</label> <select id=\"volume-option\" class=\"form-control\"> ")
    ;  _.each(locals.volumeOptions, function(option){ 
    ; __append(" <option value=\"")
    ; __append(escapeFn( option ))
    ; __append("\">")
    ; __append(escapeFn( option ))
    ; __append("</option> ")
    ;  }); 
    ; __append(" </select> </div> <div class=\"form-group\"> <label for=\"comments\">Tell us why you're interested in ")
    ; __append(escapeFn( locals.source ))
    ; __append("</label> <textarea id=\"comments\" class=\"form-control\" rows=\"3\" maxlength=\"")
    ; __append(escapeFn( locals.textAreaMaxLength ))
    ; __append("\"></textarea> <div class=\"small\">Characters Remaining: <span id=\"chars-remaining\"></span></div> </div> </section> <section class=\"modal-footer\"> <button class=\"btn btn-red cancel\" type=\"button\"> Cancel </button> <button class=\"btn btn-blue pull-right\" type=\"submit\"> Submit </button> </section> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/lead_gather_modal.ejs
// module id = 892
// module chunks = 1